import { memo } from "react";
import { TopBarHeading } from "../../../atoms/Headings";
import {
  DetailPageTopBarAccentDividerElement,
  DetailPageTopBarBreadcrumbElement,
  DetailPageTopBarTitleBlockElement,
  DetailPageTopBarTitleRowElement,
} from "./TopBar.styles";

/**
 * Vertical accent divider between back navigation and the title block.
 */
const DetailPageTopBarAccentDivider = memo(() => {
  return <DetailPageTopBarAccentDividerElement aria-hidden="true" />;
});

/**
 * Uppercase breadcrumb trail shown under the detail page title.
 */
const DetailPageTopBarBreadcrumb = memo(({ segments = [] }) => {
  const trail = segments.filter(Boolean);
  if (trail.length === 0) return null;

  return (
    <DetailPageTopBarBreadcrumbElement>
      {trail.map((segment, index) => (
        <span key={`${segment}-${index}`}>
          {index > 0 && <span>/</span>}
          {segment}
        </span>
      ))}
    </DetailPageTopBarBreadcrumbElement>
  );
});

/**
 * Title block with optional status/actions on the title row and breadcrumbs below.
 */
const DetailPageTopBarTitleBlock = memo(({ title, breadcrumbSegments = [], titleAddon = null }) => {
  return (
    <DetailPageTopBarTitleBlockElement>
      <DetailPageTopBarTitleRowElement>
        <TopBarHeading>{title}</TopBarHeading>
        {titleAddon}
      </DetailPageTopBarTitleRowElement>
      <DetailPageTopBarBreadcrumb segments={breadcrumbSegments} />
    </DetailPageTopBarTitleBlockElement>
  );
});

export {
  DetailPageTopBarAccentDivider,
  DetailPageTopBarBreadcrumb,
  DetailPageTopBarTitleBlock,
};
